import {UPDATE_MANAGER_CHANGE_ORDER_DETAIL_STATUS_REQUEST, UPDATE_MANAGER_CHANGE_ORDER_DETAIL_STATUS_RESET, UPDATE_MANAGER_CHANGE_ORDER_BASED_STATUS_REQUEST, UPDATE_MANAGER_CHANGE_ORDER_BASED_STATUS_RESET, LOAD_GET_ORDER_DETAIL_COUNT_BY_STATUS_REQUEST, LOAD_GET_ORDER_DETAIL_COUNT_BY_STATUS_SUCCESS, LOAD_GET_ORDER_DETAIL_COUNT_BY_STATUS_FAILURE, UPDATE_MANAGER_CHANGE_ORDER_FORCE_CANCEL_REQUEST, UPDATE_MANAGER_CHANGE_ORDER_FORCE_CANCEL_RESET, UPDATE_MANAGER_CHANGE_ORDER_DELIVERY_READY_UPDATE_REQUEST, UPDATE_MANAGER_CHANGE_ORDER_DELIVERY_READY_UPDATE_RESET, UPDATE_MANAGER_CHANGE_ORDER_STATUS_REQUEST, UPDATE_MANAGER_CHANGE_ORDER_STATUS_RESET, VBANK_REFUND_REQUEST, VBANK_REFUND_RESET} from './type';

export const managerChangeOrderDetailStatusAction = (orderDetailSeq, data) => ({
  type: UPDATE_MANAGER_CHANGE_ORDER_DETAIL_STATUS_REQUEST,
  orderDetailSeq,
  data,
});

export const managerChangeOrderDetailStatusResetAction = () => ({
  type: UPDATE_MANAGER_CHANGE_ORDER_DETAIL_STATUS_RESET,
});

export const managerChangeOrderBasedStatusAction = (orderSeq, data) => ({
  type: UPDATE_MANAGER_CHANGE_ORDER_BASED_STATUS_REQUEST,
  orderSeq,
  data,
});

export const managerChangeOrderBasedStatusResetAction = () => ({
  type: UPDATE_MANAGER_CHANGE_ORDER_BASED_STATUS_RESET,
});

export const managerChangeOrderStatusAction = (orderSeq, data) => ({
  type: UPDATE_MANAGER_CHANGE_ORDER_STATUS_REQUEST,
  orderSeq,
  data,
});

export const managerChangeOrderStatusResetAction = () => ({
  type: UPDATE_MANAGER_CHANGE_ORDER_STATUS_RESET,
});

export const loadGetOrderDetailCountByStatusAction = division => ({
  type: LOAD_GET_ORDER_DETAIL_COUNT_BY_STATUS_REQUEST,
  division,
});

export const managerChangeOrderForceCancelAction = orderSeq => ({
  type: UPDATE_MANAGER_CHANGE_ORDER_FORCE_CANCEL_REQUEST,
  orderSeq,
});

export const managerChangeOrderForceCancelResetAction = () => ({
  type: UPDATE_MANAGER_CHANGE_ORDER_FORCE_CANCEL_RESET,
});

export const managerChangeOrderDeliveryReadyUpdateAction = orderSeq => ({
  type: UPDATE_MANAGER_CHANGE_ORDER_DELIVERY_READY_UPDATE_REQUEST,
  orderSeq,
});

export const managerChangeOrderDeliveryReadyUpdateResetAction = () => ({
  type: UPDATE_MANAGER_CHANGE_ORDER_DELIVERY_READY_UPDATE_RESET,
});

/**
 * @typedef {Object} VbankRefundAccount
 * @property {string} bankCode      이니시스 은행코드 (BankCodeMap 키). 고객 신청 returnInfo.bankCode.
 * @property {string} bankName      은행명 (표시/로그용)
 * @property {string} accountNum    환불받을 계좌번호 (평문, 고객 신청 returnInfo.bankNum)
 * @property {string} accountHolder 예금주명 (고객 신청값 prefill + 관리자 수정 가능)
 */

/**
 * @typedef {Object.<string, {value: number, checked: boolean}>} VbankRefundDetailCheckbox
 */

/**
 * 가상계좌(VBANK) 관리자 승인 PG 환불 실행
 * POST admin/orders/:orderSeq/vbankRefund 호출. checked=true 인 detail 만 환불.
 * @param {string|number} orderSeq - 주문 시퀀스 (orders.seq)
 * @param {{detailCheckbox: VbankRefundDetailCheckbox, message: string, refundAccount: VbankRefundAccount}} data - 요청 본문
 * @returns {{type: string, orderSeq: (string|number), data: object}}
 */
export const vbankRefundAction = (orderSeq, data) => ({
  type: VBANK_REFUND_REQUEST,
  orderSeq,
  data,
});

/**
 * 가상계좌 환불 상태 초기화
 * @returns {{type: string}}
 */
export const vbankRefundResetAction = () => ({
  type: VBANK_REFUND_RESET,
});
